<template>
  <div>
    <p>
      Koemans Vastgoed is een vastgoedonderneming actief in de regio Den Haag.
      Onze focus ligt op strategische locaties met commerciële potentie, zoals
      winkelpanden en andere bedrijfsruimtes in aantrekkelijke delen van de
      stad. We richten ons op het realiseren van duurzame huurrelaties met
      betrouwbare huurders.
    </p>
    <p>
      Bent u als ondernemer op zoek naar een geschikte locatie voor uw winkel of
      onderneming in Den Haag? Neem contact met ons op!
    </p>
    <p>
      Wij geloven in duidelijke afspraken, professioneel onderhoud en een goede
      relatie met onze huurders. Dat vormt de basis van ons dagelijks werk.
      Koemans Vastgoed combineert lokale marktkennis met een lange termijn
      visie. Op die manier dragen wij bij aan een aantrekkelijk en levendig
      ondernemersklimaat in Den Haag.
    </p>
  </div>
</template>

<script>
export default {
  name: "InfoComponent",
};
</script>

<style scoped>
p {
  margin-bottom: 1rem;
  line-height: 1.6;
}
</style>
